import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const ContactUs = () => {
  const navigate = useNavigate();
  const theme = useSelector((state) => state.theme.theme); // Replace with your actual theme state path
  const isDarkTheme = theme === "dark";

  const handleNavigate = () => {
    navigate("/");
  };

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div
        className={`container mx-auto pt-14 ${
          isDarkTheme ? "text-white bg-black" : "text-black bg-gray-100"
        }`}
      >
        <div className="py-10 px-6 md:px-12 lg:px-20">
          {/* Heading Section */}
          <h1
            className={`relative md:text-5xl text-3xl font-extrabold mb-6 border-l-8 pl-4 ${
              isDarkTheme
                ? "text-[#5b53fb] border-[#5b53fb]"
                : "text-[#5b53fb] border-[#5b53fb]"
            }`}
          >
            <span className="z-10 flex md:justify-center justify-start bg-clip-text text-transparent bg-gradient-to-r from-[#5b53fb] to-[#5b53fb]">
              Contact Us
            </span>
            {/* <div className="absolute inset-0 bg-gradient-to-r from-[#5b53fb] to-transparent blur-lg opacity-70"></div> */}
          </h1>
          <p
            className={`text-xl leading-relaxed ${
              isDarkTheme ? "text-gray-300" : "text-gray-700"
            }`}
          >
            We’d love to hear from you! Whether you have questions, need
            assistance, or just want to share your travel experiences, feel free
            to reach out to us.
          </p>

          {/* Contact Details Section */}
          <div className="mt-10 grid md:grid-cols-2 gap-8">
            {/* Contact Information */}
            <div>
              <h2
                className={`text-3xl font-bold mb-4 ${
                  isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                }`}
              >
                Get in Touch
              </h2>
              <p
                className={`text-lg mb-4 ${
                  isDarkTheme ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Our team is here to help 24/7. Reach out to us using the
                information below:
              </p>
              <ul
                className={`space-y-4 text-lg ${
                  isDarkTheme ? "text-gray-300" : "text-gray-700"
                }`}
              >
                <li>
                  <span
                    className={`font-bold ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Email:
                  </span>{" "}
                  <br />
                  <a
                    href="mailto:support@tripdekhoo.com"
                    className={`underline ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    support@tripdekhoo.com
                  </a>
                  <br />
                  <a
                    href="mailto:info@tripdekhoo.com"
                    className={`underline ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    info@tripdekhoo.com
                  </a>
                </li>
                <li>
                  <span
                    className={`font-bold ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Phone:
                  </span>{" "}
                  <br />
                  Mobile: <a href="tel:7742386069">+91 7742386069</a> <br />
                </li>
                <li>
                  <span
                    className={`font-bold ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Address:
                  </span>{" "}
                  <br />
                  RTech Capital Highstreet, Plot No- CP1-231, Apparel Park, Main
                  Mahal Rd, Jagatpura, <br />
                  Jaipur, Rajasthan 302017
                </li>
              </ul>
            </div>

            {/* Contact Form */}
            <div>
              <h2
                className={`text-3xl font-bold mb-4 ${
                  isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                }`}
              >
                Send Us a Message
              </h2>
              <form className="space-y-6">
                <div>
                  <label
                    htmlFor="name"
                    className={`block text-lg font-medium ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Enter your name"
                    className={`w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 ${
                      isDarkTheme
                        ? "bg-gray-800 text-gray-300 focus:ring-[#5b53fb]"
                        : "bg-white text-gray-800 focus:ring-[#5b53fb]"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className={`block text-lg font-medium ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    className={`w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 ${
                      isDarkTheme
                        ? "bg-gray-800 text-gray-300 focus:ring-[#5b53fb]"
                        : "bg-white text-gray-800 focus:ring-[#5b53fb]"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor="message"
                    className={`block text-lg font-medium ${
                      isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                    }`}
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    placeholder="Write your message here"
                    className={`w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 ${
                      isDarkTheme
                        ? "bg-gray-800 text-gray-300 focus:ring-[#5b53fb]"
                        : "bg-white text-gray-800 focus:ring-[#5b53fb]"
                    }`}
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className={`w-full px-6 py-3 font-bold rounded-lg transition duration-300 ${
                    isDarkTheme
                      ? "bg-[#5b53fb] hover:bg-indigo-700 hover:text-white"
                      : "bg-[#5b53fb] text-white hover:bg-indigo-700"
                  }`}
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div
        className={`py-16 px-6 md:px-12 lg:px-20 text-center ${
          isDarkTheme ? "bg-[#5b53fb] text-black" : "bg-[#5b53fb] text-white"
        }`}
      >
        <h2 className="text-4xl font-extrabold mb-4">
          Ready to Plan Your Next Trip?
        </h2>
        <p className="text-xl leading-relaxed mb-8">
          Let us help you create unforgettable memories. Reach out today and
          start planning your dream vacation with TripDekhoo!
        </p>
        <button
          onClick={handleNavigate}
          className={`px-6 py-3 font-bold rounded-lg transition duration-300 ${
            isDarkTheme
              ? "bg-indigo-300 text-white hover:bg-indigo-400 hover:text-black"
              : "bg-white text-[#5b53fb] hover:bg-indigo-300 hover:text-gray-100"
          }`}
        >
          Contact Us Now
        </button>
      </div>
    </>
  );
};

export default ContactUs;
